import React, { Component } from "react";
import { connect } from "react-redux";
import { contentfulClient } from "../App";
import Radium from "radium";
import { sm, md, lg } from "../utilities/styles";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { splashCropStyles, headerSubtitleStyles } from "./Trends";
import ReactMarkdown from "react-markdown";
import PeopleViewer from "../components/PeopleViewer";
import { responsiveSliderSettings } from "../utilities/ui";

const basePanelImage = "/images/images-about-panel/cropped/image";

const panelImages = [];
let i = 8;

for (i; i <= 25; i++) {
  panelImages.push(basePanelImage + i + "-cropped.jpg");
}

const orgLinkStyles = {
  maxWidth: "80px",
  padding: "1em",
  opacity: 0.6,
  ":hover": {
    opacity: ".9",
  },
};
sm(orgLinkStyles, { maxWidth: "100px" });
md(orgLinkStyles, { maxWidth: "130px" });

const humanlySectionOverlayStyles = {
  width: "calc(.45 * 660px)",
  position: "absolute",
  left: "calc(60%)",
  top: "100px",
  textAlign: "left",
  display: "none",
};

lg(humanlySectionOverlayStyles, { display: "block" });

const OrgLink = (keyPrefix) => (o, i) => (
  <a href={o.link} target="_blank">
    <img key={keyPrefix + i} src={o.logo + "?w=130"} alt={o.name} style={orgLinkStyles} />
  </a>
);

class AboutPage extends Component {
  componentWillMount() {
    if (!this.props.aboutPageLoaded) {
      this.props.fetchAboutPage();
    }
  }

  componentDidMount() {
    const { fetchPeopleCategories } = this.props;
    fetchPeopleCategories();
  }

  render() {
    const { aboutPage, peopleCategories } = this.props;

    const { clients, press } = aboutPage;
    const teamPeopleCategory = peopleCategories.find(
      (cat) => cat.name.toLowerCase() === "our staff",
    );
    const teamPeople = teamPeopleCategory ? teamPeopleCategory.people : [];

    return (
      <div style={{ paddingTop: "3em" }}>
        <section className="about">
          {aboutPage.splash && (
            <div style={splashCropStyles}>
              <section className="intro__header px3">
                <h1 className="mb0">{aboutPage.title}</h1>
                <h3 style={headerSubtitleStyles}>{aboutPage.subtitle}</h3>
              </section>
              <img src={aboutPage.splash} />
            </div>
          )}
          <section className="intro__header-mobile px3 mt2 mb4">
            <h1 className="mb0">{aboutPage.title}</h1>
            <h3 className="thin">{aboutPage.subtitle}</h3>
          </section>
          <section className="services">
            <div className="pb2 center">
              <div className="px2">
                <h2>{aboutPage.secondSectionHeader}</h2>
                <h3 className="thin">{aboutPage.secondSectionSubtitle}</h3>
              </div>
            </div>
            <div className="clearfix mb4 center px2">
              <div className="md-col md-col-4 px3 mb3">
                <h3 className="mb1">{aboutPage.secondSectionCol1Title}</h3>
                <h3 className="my1 thin">{aboutPage.secondSectionCol1Subtitle}</h3>
                <p className="mt1">{aboutPage.secondSectionCol1Description}</p>
              </div>
              <div className="md-col md-col-4 px3 mb3">
                <h3 className="mb1">{aboutPage.secondSectionCol2Title}</h3>
                <h3 className="my1 thin">{aboutPage.secondSectionCol2Subtitle}</h3>
                <p className="mt1">{aboutPage.secondSectionCol2Description}</p>
              </div>
              <div className="md-col md-col-4 px3 mb3">
                <h3 className="mb1">{aboutPage.secondSectionCol3Title}</h3>
                <h3 className="my1 thin">{aboutPage.secondSectionCol3Subtitle}</h3>
                <p className="mt1">{aboutPage.secondSectionCol3Description}</p>
              </div>
            </div>
            <section className=" mb4 px2 center ">
              <h2>Our Team</h2>
              <h3 className="thin mb4">{aboutPage.ourTeamSectionDescription}</h3>
              <div className="panels center about-page-team-section">
                <div className="about-page-team-section-image">
                  <img src={aboutPage.teamImage} />
                </div>
                <div className="team-description-markdown-container about-page-team-section-description">
                  <ReactMarkdown source={aboutPage.teamDescription} escapeHtml={false} />
                </div>
              </div>
            </section>
            <div className="clearfix mb4 center px2">
              <h2>Cultural Advisors</h2>
              <h3 className="thin mb4">{aboutPage.culturalAdvisorsSectionDescription}</h3>
              <PeopleViewer peopleCategories={peopleCategories} />
            </div>
            {aboutPage.splash2 && <img src={aboutPage.splash2} />}
          </section>
          <section className="panels mb4 px2 center">
            <h2>{aboutPage.thirdSectionTitle}</h2>
            <h3 className="thin mb4">{aboutPage.thirdSectionSubtitle}</h3>
            <Slider
              autoplay={true}
              autoplaySpeed={2500}
              arrows={false}
              speed={500}
              slidesToShow={6}
              slidesToScroll={2}
              infinite={true}
              responsive={responsiveSliderSettings}
            >
              {aboutPage.culturePanelHeadshots.map((src) => {
                return <img src={src} style={{ width: "110px" }} />;
              })}
            </Slider>
          </section>
          <section className="humanly mb4 center">
            <h2>{aboutPage.humanlyTitle}</h2>
            <h3 className="mb3 thin"></h3>
            <div style={{ backgroundColor: "#EEE", padding: "2em 1em" }}>
              <div className="lg-flex justify-center">
                <img
                  src="/images/issues_stack_3.png"
                  alt="Stack of humanly magazine issues"
                />
                <div
                  className="pt3 center mx-auto"
                  style={{ width: "400px", maxWidth: "100%" }}
                >
                  <ReactMarkdown
                    source={aboutPage.humanlyTestimonial}
                    escapeHtml={false}
                  />
                  <p>{aboutPage.humanlySubtitle}</p>
                  <h3>
                    <a href="http://eepurl.com/diY0E5">
                      <button>Request Humanly</button>
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </section>

          <section className="clients mb4 px2 center">
            <h2>Clients & Press</h2>
            <div style={{ maxWidth: "100%", width: "1000px" }} className="mx-auto">
              <div className="border-bottom border-gray pb2 mb2">
                {clients.map(OrgLink("c"))}
              </div>
              {press.map(OrgLink("p"))}
            </div>
          </section>
          <div className="center">
            <img src={aboutPage.bottomSplash + "?w=1500"} />
          </div>
          <div className="p3 center">
            <h3>
              <a href="mailto:info@culture.life">
                <button>Contact Us</button>
              </a>
            </h3>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    peopleCategories: state.peopleCategories,
    aboutPageLoaded: state.loaders.aboutPage,
    aboutPage: state.aboutPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAboutPage() {
      contentfulClient.getEntries({ content_type: "aboutPage" }).then((response) => {
        dispatch({ type: "LOAD_ABOUT_PAGE", content: response });
      });
    },
    fetchPeopleCategories: () => {
      contentfulClient
        .getEntries({ content_type: "peopleCategory" })
        .then((response) => {
          console.log(response);
          dispatch({ type: "LOAD_PEOPLE_CATEGORIES", content: response });
        })
        .catch(console.log);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Radium(AboutPage));



// WEBPACK FOOTER //
// ./src/pages/About.js